import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../lib/api/auth";
import { useAuthDispatch, LOGIN } from "../../context/AuthContext";
import AuthTemplate from "../../components/auth/AuthTemplate";
import AuthForm from "../../components/auth/AuthForm";

const validate = ({ username, password }) => {
  //console.log(`로그인: ${username}`);
  if (username.length < 3 || username.length > 10) {
    alert("아이디는 3자 이상, 10자 미만으로 작성하셔야 합니다.");
    return false;
  }
  return true;
};

const Login = () => {
  const navigate = useNavigate();
  const authDispatch = useAuthDispatch();
  const [values, setValues] = useState({
    username: "",
    password: "",
  });

  const handleClickSubmit = async (e) => {
    e.preventDefault();
    if (validate({ ...values }) === false) {
      return;
    }

    try {
      const { username, password } = values;
      const { status, displayName, accessToken, refreshToken, roler, message } =
        await login({
          username,
          password,
        });

      if (status >= 200 && status < 300) {
        authDispatch({
          type: LOGIN,
          loggedUser: {
            displayName,
            roler,
            accessToken,
            refreshToken,
          },
        });

        navigate("/", { replace: true });
      } else {
        alert(message);
      }
    } catch (error) {
      // console.log(error);
      if (error.response) {
        const {
          status,
          data: { message },
        } = error.response;
        console.log("status : ", status);
        console.log("message : ", message);
      }
    }
  };

  const handleChangeValues = (e) => {
    const { name, value } = e.target;
    setValues((current) => {
      return { ...current, [name]: value };
    });
  };

  return (
    <AuthTemplate>
      <AuthForm
        values={values}
        onChangeValues={handleChangeValues}
        onClickSubmit={handleClickSubmit}
      ></AuthForm>
    </AuthTemplate>
  );
};

export default Login;
